import { Form, Icon } from 'semantic-ui-react';
import { useForm } from '~/hooks/providers/FormContextProvider';
import { FormSchemaAwareWidget } from '~/components/form';
import { usePortfolioContext, useProjectContext } from '~/hooks';
import { useAddProjectDeadline } from '~/mutations/project/useAddProjectDeadline';
import React, { useEffect, useRef } from 'react';
import { isEqual } from 'lodash';
import { withForm } from '~/utils/withForm';

interface BidDeadlineFormState {
  bidDeadline: string;
}

const defaults: BidDeadlineFormState = { bidDeadline: '' };

const BidDeadlineForm: React.FC = withForm({ defaults }, () => {
  const { formState, updateFormValue } = useForm<BidDeadlineFormState>();
  const { portfolio, updatePortfolioValue } = usePortfolioContext();
  const { project, updateProjectValue } = useProjectContext();
  const isPortfolio = portfolio?.projects;

  defaults.bidDeadline = portfolio?.bidDeadline ?? project?.bidDeadline;

  const { mutateAsync: updateProjectBidDeadline } = useAddProjectDeadline() as any;
  const handleSubmit = async () => {
    if (updatePortfolioValue && isPortfolio) {
      updateProjectBidDeadline({ portfolioId: portfolio.id, date: formState.bidDeadline });
      updatePortfolioValue('bidDeadline', formState.bidDeadline, { doSave: false });
    } else if (project) {
      updateProjectBidDeadline({ projectId: project.id, date: formState.bidDeadline });
      updateProjectValue('bidDeadline', formState.bidDeadline, { doSave: false });
    }
  };

  const findInvitationStatus = () => {
    const invitationStatus = project?.investorQueue?.map?.((investor: any) => investor.status);
    return invitationStatus;
  };  

  const formStateRef = useRef(formState);
  const autoSaveUserInfoTimeoutRef = useRef(handleSubmit) as any;
  const deadlineEmptyErrorRef = useRef() as any;
  useEffect(() => {
    const matchStatus = findInvitationStatus();
    const isInvited = matchStatus?.includes('INVITED');
 
    if (formState.bidDeadline === null && isInvited) {
      deadlineEmptyErrorRef.current = true;
    } else {
      deadlineEmptyErrorRef.current = false;
    }

    if (!deadlineEmptyErrorRef.current && !isEqual(formState, formStateRef.current)) {
      if (autoSaveUserInfoTimeoutRef.current) {
        clearTimeout(autoSaveUserInfoTimeoutRef.current);
      }
      autoSaveUserInfoTimeoutRef.current = setTimeout(handleSubmit, 3000);
      formStateRef.current = formState;
    }
  }, [formState]);

  const handleClear = () => updateFormValue('bidDeadline', '');

  return (
    <div style={{ position: 'relative', width: '200px' }}>
      <Form style={{ width: '200px', marginBottom: '0' }}>
        <FormSchemaAwareWidget
          datepicker
          fieldLabel="Bid deadline"
          schemaKey="bidDeadline"
          onBlur={() => {
            if (deadlineEmptyErrorRef.current) {
              const currentBidDeadline = project?.bidDeadline ?? portfolio?.bidDeadline;
              updateFormValue('bidDeadline', currentBidDeadline);
            }
          }}
        />
      </Form>
      {formState.bidDeadline && (
        <Icon
          name="close"
          link
          onClick={handleClear}
          style={{
            position: 'absolute',
            right: 10,
            top: 35,
            margin: 0,
            padding: 0,
            cursor: 'pointer',
            fontSize: '0.9em',
            opacity: 0.7,
          }}
        />
      )}
    </div>
  );
});

export default BidDeadlineForm;
